import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vueI18n from './i18n/locale'
import './common-main' // 公共的配置，给vue脚手架和storybook脚手架共用的
// import '@/lib/wsgsdk/wsgchallenge'; //挑战应答
// 安全sdk初始化
import '@/lib/wsgsdk/wsgenv'
import './omega/observer/index.js'
import screenSizeType from '@/utils/screenSizeType'

Vue.use(screenSizeType, {
  store,
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  i18n: vueI18n,
}).$mount('#app')
